export const HOME_PAGE_LOAD_READY = 'HOME_PAGE_LOAD_READY'; // eslint-disable-line
export const FINDASTORE_PAGE_LOAD_READY = 'FINDASTORE_PAGE_LOAD_READY';
